import { createContext } from 'react';

import { MerchantPublicConfigurationModel } from '@merchant-clients/configuration';

export const MerchantPublicConfigurationContext = createContext<
  MerchantPublicConfigurationModel | undefined
>(undefined);
